import { render, staticRenderFns } from "./ModifyViewers.vue?vue&type=template&id=0d0d0736&"
import script from "./ModifyViewers.vue?vue&type=script&lang=js&"
export * from "./ModifyViewers.vue?vue&type=script&lang=js&"
import style0 from "./ModifyViewers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports